import axios from "axios";
import {Base_URL} from "../url"


//const API_URL = "http://192.168.29.242:5090/api/ExpensesDetails";

export const saveExpenseDetails = async (expenseData) => {
  try {
    console.log(expenseData)
    const formData = new FormData();
    for (const key in expenseData) {
      formData.append(key, expenseData[key]);
    }

    const response = await axios.post(`${Base_URL}/ExpensesDetails`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving expense!";
  }
};
